import { FC } from 'react';
import SkeletonGuildDetailsPage from './SkeletonGuildDetailsPage';
import SkeletonGuildRosterPage from './SkeletonGuildRosterPage';
import SkeletonGuildMythicPlusPage from './SkeletonGuildMythicPlusPage';
import SkeletonGuildRaidAchievementsPage from './SkeletonGuildRaidAchievementsPage';
import SkeletonGuildRaidCompositionPage from './SkeletonGuildRaidCompositionPage';
import { useGuildPagesVisibility } from './hooks/useGuildPagesVisibility';

const SkeletonGuildPages: FC<any> = () => {
  const { stats, profile, roster, mythicPlus, raidAchievements, raidEncounters } = useGuildPagesVisibility();

  return (
    <>
      {stats && null}
      {profile && <SkeletonGuildDetailsPage />}
      {roster && <SkeletonGuildRosterPage />}
      {mythicPlus && <SkeletonGuildMythicPlusPage />}
      {raidAchievements && <SkeletonGuildRaidAchievementsPage />}
      {raidEncounters && <SkeletonGuildRaidCompositionPage />}
    </>
  );
};

export default SkeletonGuildPages;

